import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authorizations-settings',
  templateUrl: './authorizations-settings.component.html',
  styleUrls: ['./authorizations-settings.component.scss']
})
export class AuthorizationsSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
